module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.4882/images/default-company-avatar.png"